// src/store/slices/audioSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AudioItem } from '../../components/textplayer/types';

interface AudioState {
    currentSentence: number;
    playbackSpeed: number;
    isPlaying: boolean;
    audioItems: AudioItem[];
    loading: boolean;
    error: string | null;
    courseId: number;
    lessonId: number;
}

const initialState: AudioState = {
    currentSentence: 0,
    playbackSpeed: 1.0,
    isPlaying: false,
    audioItems: [],
    loading: false,
    error: null,
    courseId: 0,
    lessonId: 0,
};

const audioSlice = createSlice({
    name: 'audio',
    initialState,
    reducers: {
        setCurrentSentence: (state, action: PayloadAction<number>) => {
            state.currentSentence = action.payload;
        },
        setPlaybackSpeed: (state, action: PayloadAction<number>) => {
            state.playbackSpeed = action.payload;
        },
        setIsPlaying: (state, action: PayloadAction<boolean>) => {
            state.isPlaying = action.payload;
        },
        setAudioItems: (state, action: PayloadAction<AudioItem[]>) => {
            state.audioItems = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        setCourseId: (state, action: PayloadAction<number>) => {
            state.courseId = action.payload;
        },
        setLessonId: (state, action: PayloadAction<number>) => {
            state.lessonId = action.payload;
        },
    },
});

export const {
    setCurrentSentence,
    setPlaybackSpeed,
    setIsPlaying,
    setAudioItems,
    setLoading,
    setError,
    setCourseId,
    setLessonId,
} = audioSlice.actions;

export default audioSlice.reducer;